import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

const readBannerPath = (props?: { [key: string]: string }): string | undefined =>
    props?.bannerImagePath || props?.BannerImagePath;

export const mapCategoryBannerStateToProps = (state: ApplicationState) => {
    const categoryPath = getSelectedCategoryPath(state) || getLocation(state).pathname;
    const catalogPage = getCatalogPageStateByPath(state, categoryPath).value;
    const categoryId = catalogPage?.categoryIdWithBrandId ?? catalogPage?.categoryId;

    const categoryState = categoryId ? getCategoryState(state, categoryId) : undefined;
    const category = categoryState?.value;

    const parentCategoryId = category?.parentId ?? undefined;
    const parentState = parentCategoryId ? getCategoryState(state, parentCategoryId) : undefined;
    const parentCategory = parentState?.value;

    const imagePath = readBannerPath(category?.properties) || readBannerPath(parentCategory?.properties);
    const altText = category?.imageAltText || category?.name;

    return {
        categoryId,
        category,
        categoryIsLoading: categoryState?.isLoading ?? false,
        parentCategoryId,
        parentCategory,
        parentIsLoading: parentState?.isLoading ?? false,
        imagePath,
        altText,
    };
};

export const categoryBannerDispatch = {
    loadCategory,
};
